module.exports = __webpack_public_path__ + "static/media/admin.9d93b940.jpg";